/**
 * Put custom javascript functions for your theme here
 */ /**
 * File navigation.js.
 *
 * Handles showing / hiding main nav on scroll
 * and toggling the navigation menu for small screens.
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 */ (function($) {
    // ----------------------------------------------------------
    // Doc ready
    // ----------------------------------------------------------
    $(document).ready(()=>{
        // Main Navigation - depends on superfish-1.7.3-yui.
        // if ($('.main-menu.sf-menu').length) {
        //     $('.main-menu.sf-menu').superfish(
        //         {
        //             animation: {opacity: 'show'}, // fade-in and slide-down animation.
        //             autoArrows: false,  // disable generation of arrow mark-up.
        //             delay: 0, // delays on mouseout.
        //             speed: 200 // faster animation speed.
        //         }
        //     );
        // }
        // ----------------------------------------------------------
        // Main Navigation open / close submenus
        // ----------------------------------------------------------
        if ($(".main-menu").length) {
            const mainNavMediaQuery = window.matchMedia("(max-width: 1199px)");
            function handleViewportChange(e) {
                // Check if the media query is true
                if (e.matches) {
                    $(document).on("click tap keyup", ".main-menu .menu-item-has-children > a", function(e) {
                        let myLi = $(this).parent(".menu-item-has-children");
                        // let mySub = $(this).next('.sub-menu');
                        // if (myLi.hasClass('submenu-open') || myLi.hasClass('current-menu-item') || myLi.hasClass('current-menu-ancestor')) {
                        if (myLi.hasClass("submenu-open")) return true;
                        else {
                            e.preventDefault();
                            $(myLi).siblings(".menu-item-has-children").removeClass("submenu-open");
                            $(myLi).addClass("submenu-open");
                        }
                    });
                    // hide sub-menu on ESC.
                    $(document).on("keyup", function(e) {
                        if (e.keyCode === 13) return true;
                        if (e.which === 27) $(".menu-item-has-children").removeClass("submenu-open");
                    });
                    // hide opened menu by clicking outside it.
                    $(document).on("click tap keyup", function(e) {
                        if (!$(e.target).closest(".main-menu").length) $(".menu-item-has-children").removeClass("submenu-open");
                    });
                } else {
                    $(document).off("click tap keyup", ".main-menu .menu-item-has-children > a");
                    let menu_lis = document.querySelectorAll(".submenu-open");
                    menu_lis.forEach((menu_li)=>{
                        let menu_li_link = menu_li.querySelector("a");
                        let menu_li_btn = menu_li.querySelector("button");
                        menu_li_btn.blur();
                        menu_li_link.blur();
                        menu_li.classList.remove("submenu-open");
                    });
                }
            }
            $(document).on("click tap keyup", ".submenu-toggle", function(e) {
                let myLi = $(this).parent(".menu-item-has-children");
                if (myLi.hasClass("submenu-open")) $(myLi).removeClass("submenu-open");
                else {
                    e.preventDefault();
                    $(myLi).siblings(".menu-item-has-children").removeClass("submenu-open");
                    $(myLi).addClass("submenu-open");
                }
            });
            // Register event listener
            mainNavMediaQuery.addEventListener("change", handleViewportChange);
            // Initial check
            handleViewportChange(mainNavMediaQuery);
        } // end if main menu exists.
    }); // end doc.ready.
})(window.jQuery);
(function(window1, document1, undefined) {
    // MOBILE SLIDER MENU
    // http://coding.smashingmagazine.com/2013/01/15/off-canvas-navigation-for-responsive-website/
    // helper functions.
    const trim = function(str) {
        return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    };
    const hasClass = function(el, cn) {
        return (" " + el.className + " ").indexOf(" " + cn + " ") !== -1;
    };
    const addClass = function(el, cn) {
        if (!hasClass(el, cn)) el.className = el.className === "" ? cn : el.className + " " + cn;
    };
    const removeClass = function(el, cn) {
        if (el) el.className = trim((" " + el.className + " ").replace(" " + cn + " ", " "));
    };
    const setAttributes = function(el, attrs) {
        if (el) for(let key in attrs)el.setAttribute(key, attrs[key]);
    };
    const hasParent = function(el, id) {
        if (el) do {
            if (el.id === id) return true;
            if (el.nodeType === 9) break;
        }while (el = el.parentNode);
        return false;
    };
    // normalize vendor prefixes.
    const doc = document1.documentElement;
    // off-canvas slider actions.
    window1.App = function() {
        let _init = false;
        const app = {};
        const site_nav = document1.getElementById("site-nav"), header_toggle_btn = document1.getElementById("header-menu-toggle"), btn_class = "is-active", nav_class = "js-nav";
        let nav_open = false;
        app.init = function() {
            if (_init) return;
            _init = true;
            app.closeNav = function() {
                if (nav_open) {
                    setAttributes(header_toggle_btn, {
                        "title": "Main Menu",
                        "aria-expanded": "false"
                    });
                    setAttributes(site_nav, {
                        "aria-expanded": "false"
                    });
                }
                removeClass(doc, nav_class);
                removeClass(header_toggle_btn, btn_class);
                nav_open = false;
            };
            app.openNav = function() {
                if (nav_open) return;
                addClass(doc, nav_class);
                addClass(header_toggle_btn, btn_class);
                setAttributes(header_toggle_btn, {
                    "title": "Close Menu",
                    "aria-expanded": "true"
                });
                setAttributes(site_nav, {
                    "aria-expanded": "true"
                });
                nav_open = true;
            };
            app.toggleNav = function(e) {
                if (nav_open && hasClass(doc, nav_class)) app.closeNav();
                else app.openNav();
                if (e) {
                    e.stopPropagation();
                    e.preventDefault();
                }
            };
            // open nav with main "nav" button.
            if (header_toggle_btn !== undefined) header_toggle_btn.addEventListener("click", app.toggleNav, false);
            // close nav by touching the partial off-screen content.
            document1.addEventListener("click", function(e) {
                if (nav_open && !hasParent(e.target, "header-container") && !hasParent(e.target, "header-search")) {
                    e.stopPropagation();
                    e.preventDefault();
                    app.closeNav();
                }
            }, true);
            addClass(doc, "js-ready");
        };
        return app;
    }();
    if (window1.addEventListener) window1.addEventListener("DOMContentLoaded", window1.App.init, false);
// end MOBILE SLIDER MENU.
})(window, window.document);


// import {gsap} from '../../gsap/gsap.min';
// import {ScrollTrigger} from '../../gsap/ScrollTrigger.min';
// alert('uh oh');
// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function() {};
    var methods = [
        "assert",
        "clear",
        "count",
        "debug",
        "dir",
        "dirxml",
        "error",
        "exception",
        "group",
        "groupCollapsed",
        "groupEnd",
        "info",
        "log",
        "markTimeline",
        "profile",
        "profileEnd",
        "table",
        "time",
        "timeEnd",
        "timeline",
        "timelineEnd",
        "timeStamp",
        "trace",
        "warn"
    ];
    var length = methods.length;
    var console1 = window.console = window.console || {};
    while(length--){
        method = methods[length];
        // Only stub undefined methods.
        if (!console1[method]) console1[method] = noop;
    }
})();
(function(window1, document1, undefined) {
    const docBody = document1.body;
    // Window load functions
    window1.addEventListener("load", function load() {
        window1.removeEventListener("load", load, false);
        docBody.classList.add("loaded");
    }, false);
    // set CSS variable for browser's scrollbar width and adjust on browser resize
    // enables 'alignfull' content to span the full width of viewport without triggering overscroll-x scrollbar
    setScrollbarWidth();
    function setScrollbarWidth() {
        const body = document1.querySelector("body");
        const scrollbar = window1.innerWidth - body.clientWidth;
        body.setAttribute("style", `--scrollbar: ${scrollbar}px`);
    }
    window1.addEventListener("resize", setScrollbarWidth);
    // GSAP 3, ScrollTrigger parallax - depends on 'gsap-js' and 'scrolltrigger-js' in homebase_scripts()
    gsap.config({
        force3D: true,
        nullTargetWarn: false
    });
    gsap.registerPlugin(ScrollTrigger);
    ScrollTrigger.config({
        limitCallbacks: true,
        ignoreMobileResize: true
    });
    // Lenis.js Smooth Scrolling - https://github.com/darkroomengineering/lenis
    const lenis = new Lenis();
    lenis.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time)=>{
        lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
    // lenis.on('scroll', (e) => {
    // 	console.log(e)
    // })
    // GSAP 3, ScrollTrigger site-header show/hide - depends on 'gsap-js' and 'scrolltrigger-js' in ppsaa_scripts()
    const siteHeader = document1.querySelector(".site-header");
    const siteHeaderHeight = siteHeader.offsetHeight;
    // add .header-top class to <body> when nearing top of page
    ScrollTrigger.create({
        start: `+=${-1 * siteHeaderHeight}`,
        // end: () => `+=${document.querySelector('.site-header').offsetHeight}`,
        end: `+=${1.34 * siteHeaderHeight}`,
        // markers:true,
        scrub: true,
        trigger: docBody,
        toggleClass: {
            className: "header-top",
            targets: docBody
        },
        onUpdate: ()=>{
            docBody.classList.remove("header-short");
        }
    });
    let param, checkParam, triggered;
    // show and hide fixed header based on scroll direction
    // adds buffer when scrolling up before header appears
    // inspiration for buffer: https://greensock.com/forums/topic/29468-scrolltrigger-on-fixed-header/#comment-147082
    ScrollTrigger.create({
        start: "top" + `+=${siteHeaderHeight * .34}`,
        end: "max",
        scrub: true,
        trigger: docBody,
        // toggleClass: {className: 'header-hide', targets: docBody},
        onUpdate: (self)=>{
            // console.log( self.scroll() )
            // console.log( self.progress )
            // console.log( self.direction )
            if (self.direction === 1 && self.scroll() !== 0) {
                triggered = false;
                param = self.scroll();
                docBody.classList.add("header-hide");
                docBody.classList.remove("header-short");
            }
            if (self.direction === -1 && !triggered) {
                checkParam = self.scroll();
                //console.log(param - checkParam)
                //if( param - checkParam >= 1000 || self.scroll() === 0 ) { // <--- Distance to be covered
                if (param - checkParam >= 40 || self.progress === 0) {
                    docBody.classList.remove("header-hide");
                    docBody.classList.add("header-short");
                    triggered = true;
                }
            }
        }
    });
    const initHeroParallax = ()=>{
        // let parallax_hero_figure = document.querySelector('.parallax-hero-figure')
        let parallax_hero_figures = gsap.utils.toArray(".parallax-hero-figure");
        // if (parallax_hero_figure) {
        parallax_hero_figures.forEach((parallax_hero_figure, i)=>{
            let parallax_hero_parent = parallax_hero_figure.parentNode;
            gsap.to(parallax_hero_figure, {
                yPercent: 40,
                ease: "none",
                scrollTrigger: {
                    trigger: parallax_hero_parent,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
        });
    };
    const initBgParallax = ()=>{
        // let parallax_hero_figure = document.querySelector('.parallax-hero-figure')
        let parallax_bg_figures = gsap.utils.toArray(".parallax-bg-figure");
        parallax_bg_figures.forEach((parallax_bg_figure, i)=>{
            let parallax_bg_parent = parallax_bg_figure.parentNode;
            gsap.to(parallax_bg_figure, {
                yPercent: 40,
                ease: "none",
                scrollTrigger: {
                    trigger: parallax_bg_parent,
                    start: "top bottom",
                    end: "bottom top",
                    scrub: true
                }
            });
        });
    };
    document1.addEventListener("DOMContentLoaded", ()=>{
        initHeroParallax();
        initBgParallax();
    });
    window1.addEventListener("resize", ()=>{});
    // //https://gsap.com/community/forums/topic/27866-only-animate-elements-visible-in-the-viewport/
    // function isInViewport(el) {
    // 	const rect = el.getBoundingClientRect();
    // 	return (
    // 		rect.top >= 0 &&
    // 		rect.left >= 0 &&
    // 		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    // 		rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    // 	);
    // }
    // Modal stuff
    const modal = document1.querySelectorAll(".site-modal");
    for(let i = 0; i < modal.length; i++)if (modal[i]) {
        const modal_close = modal[i].querySelector(".close-modal");
        [
            "click",
            "touchend"
        ].forEach(function(event) {
            modal[i].addEventListener(event, onModalClose, false);
            const modal_content = modal[i].querySelector(".modal-content");
            modal_content.addEventListener(event, function(event) {
                event.stopPropagation();
            }, false);
        });
        // let in60Seconds = 1/1440;
        function submitModal(event) {
            Cookies.set("modalDisable", "yes", {
                expires: 365
            });
        }
        // let in15Seconds = 1/5760;
        function onModalClose() {
            document1.documentElement.classList.remove("modal-visible");
            Cookies.set("modalShown", "yes", {
            });
            lastFocus.focus();
        }
        function displayModal() {
            document1.documentElement.classList.add("modal-visible");
            setTimeout(function() {
            // modal_form_input.focus();
            }, 400);
        }
        let lastFocus;
        const modalShown = Cookies.get("modalShown");
        const modalDisable = Cookies.get("modalDisable");
        if (modalDisable) console.log('"Modal Disable" cookie found. No action necessary');
        else if (modalShown) {
            // console.log('"Modal Shown" cookie found. No action necessary')
            // start show modal every visit - this is by request. comment this out to revert to session cookie
            Cookies.remove("modalShown");
            setTimeout(function() {
                lastFocus = document1.activeElement;
                displayModal();
            }, 400);
        // end show modal every visit to homepage
        } else {
            console.log("No cookie found. Opening popup in 5 seconds");
            setTimeout(function() {
                lastFocus = document1.activeElement;
                displayModal();
            }, 2500);
        }
    }
// end modal stuff
})(window, window.document);
// remap jQuery to $.
(function($) {
    // trigger when page is ready.
    $(document).ready(function() {
        /*-------------------------------------------------------------------------
			 FORMS
			 ---------------------------------------------------------------------------*/ // 'input-filled' class for focused inputs
        // used for styling, compatibility, animations, etc
        $('input:not([type="submit"]), select, textarea').each(function() {
            if ($(this).val() !== "") {
                $(this).addClass("input-filled");
                $(this).closest(".gfield").addClass("item-focused");
                $(this).closest("form").addClass("form-focused");
            }
        }).on("blur", function() {
            if ($(this).val() === "") {
                $(this).removeClass("input-filled");
                $(this).closest(".gfield").removeClass("item-focused");
                $(this).closest("form").removeClass("form-focused");
            }
        }).on("focus", function() {
            $(this).addClass("input-filled");
            $(this).closest(".gfield").addClass("item-focused");
            $(this).closest("form").addClass("form-focused");
        });
        // ----------------------------------------------------------
        // Gravity forms functions
        // ----------------------------------------------------------
        // if submission is successful, scroll to success message.
        $(document).on("gform_confirmation_loaded", ()=>{
            const $confirmationMessage = $(".gform_confirmation_message");
            if ($confirmationMessage.length) $("html, body").animate({
                scrollTop: $confirmationMessage.offset().top - 180
            }, 1000);
        });
        // gform_post_render = every time the form is rendered on the page.
        // this will scroll up to the main error message.
        $(document).on("gform_post_render", (event, formId)=>{
            // if there's an error, scroll up to error message.
            if ($(".validation_error").length) {
                const $errMessage = $(`#gform_${formId} .validation_error`);
                // do something specific for one form
                // if(formId == 1) {
                // Gravity forms already understands getting
                // the form ID as part of <form id="gform_1">
                // your function here
                // }
                // scroll to error message
                $("html, body").animate({
                    scrollTop: $($errMessage).offset().top - 180
                }, 1000);
            }
        });
        // ----------------------------------------------------------
        // Open external links in new window
        // ----------------------------------------------------------
        $("a").each(()=>{
            $.expr[":"].external = function(obj) {
                return !obj.href.match(/^mailto:/) && obj.hostname !== location.hostname && !obj.href.match(/^tel:/) && !obj.href.match(/^javascript:/) && !obj.href.match(/^http:\/\/www.youtube.com\//) && !obj.title.match(/^Pause\s*video/);
            };
            $("a:external").addClass("external").attr("target", "_blank");
        });
        // smooth scrolling to named anchors or IDs
        // https://css-tricks.com/snippets/jquery/smooth-scrolling/
        $('a[href*="#"]:not([href="#"])').on("click tap", function(e) {
            if (location.pathname.replace(/^\//, "") === this.pathname.replace(/^\//, "") || location.hostname === this.hostname) {
                let target = $(this.hash);
                target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
                if (target.length) {
                    $("html,body").animate({
                        scrollTop: target.offset().top
                    }, 400);
                    return false;
                }
            }
        });
    // // Expand/Collapse accordion sections on click.
    // $('.research-accordion-container').on(
    // 	'click keydown',
    // 	'.research-accordion-section-title button',
    // 	function(e) {
    // 		if (e.type === 'keydown' && 13 !== e.which) { // "return" key
    // 			return;
    // 		}
    // 		e.preventDefault(); // Keep this AFTER the key filter above
    // 		accordionSwitch($(this));
    // 	}
    // );
    }); // end document.ready
    // /**
    //  * Close the current accordion section and open a new one.
    //  *
    //  * @param {Object} el Title element of the accordion section to toggle.
    //  * @since 3.6.0
    //  */
    // function accordionSwitch(el)
    // {
    // 	const section = el.closest('.research-accordion-section'),
    // 		sectionToggleControl = section.find('[aria-expanded]').first(),
    // 		container = section.closest('.research-accordion-container'),
    // 		siblings = container.find('.open'),
    // 		siblingsToggleControl = siblings.find('[aria-expanded]').first(),
    // 		content = section.find('.research-accordion-section-content');
    //
    // 	// This section has no content and cannot be expanded.
    // 	if (section.hasClass('cannot-expand')) {
    // 		return;
    // 	}
    //
    // 	// Add a class to the container to let us know something is happening inside.
    // 	// This helps in cases such as hiding a scrollbar while animations are executing.
    // 	container.addClass('opening');
    //
    // 	if (section.hasClass('open')) {
    // 		section.toggleClass('open');
    // 		content.toggle(true).slideToggle(150).attr('aria-hidden', 'true');
    // 	} else {
    // 		siblingsToggleControl.attr('aria-expanded', 'false');
    // 		siblings.removeClass('open');
    // 		siblings.find('.research-accordion-section-content').slideUp(150).attr('aria-hidden', 'true');
    // 		content.toggle(false).slideToggle(150).attr('aria-hidden', 'false');
    // 		section.toggleClass('open');
    // 	}
    //
    // 	// We have to wait for the animations to finish
    // 	setTimeout(
    // 		function() {
    // 			container.removeClass('opening');
    // 		},
    // 		150
    // 	);
    //
    // 	// If there's an element with an aria-expanded attribute, assume it's a toggle control and toggle the aria-expanded value.
    // 	if (sectionToggleControl) {
    // 		sectionToggleControl.attr('aria-expanded', String(sectionToggleControl.attr('aria-expanded') === 'false'));
    // 	}
    // }
    // Video modal links - inspiration: https://codepen.io/laricoDev/pen/ExZzMeg
    document.querySelectorAll(".lvideo").forEach((e)=>e.addEventListener("click", playVideos));
    const body = document.body;
    function playVideos(e) {
        lvideo(e.currentTarget.dataset.url);
        body.classList.add("lvideo-active");
        let lvideoWrap = document.createElement("div");
        lvideoWrap.setAttribute("id", "lvideo-wrap");
        document.body.appendChild(lvideoWrap);
        // console.log(this.dataset.url)
        // console.log(this.dataset.video)
        let wrapper = document.getElementById("lvideo-wrap");
        wrapper.classList.add("active");
        const url = this.dataset.url;
        const startModal = `<span class="lvideo-overlay" data-lenis-prevent="true"></span> <div class="lvideo-container">`;
        const finishModal = `</div><button class="lvideo-close">x</button>`;
        // if (url.indexOf("youtube") !== -1) {
        if (url.indexOf("youtube") !== -1 || url.indexOf("youtu") !== -1) {
            //console.log("is youtube")
            const ytUrl = [
                this.dataset.url
            ];
            let i, r, regExp = /^.*(?:(?:youtu\.be\/|v\/|vi\/|u\/\w\/|embed\/)|(?:(?:watch)?\?v(?:i)?=|\&v(?:i)?=))([^#\&\?]*).*/;
            for(i = 0; i < ytUrl.length; ++i){
                r = ytUrl[i].match(regExp);
                //console.log(r[1])
                document.getElementById("lvideo-wrap").innerHTML = `${startModal}<iframe width="560" height="315" title="YouTube Video" src='https://www.youtube.com/embed/${r[1]}?rel=0&autoplay=1&mute=0&loop=1&playlist=${r[1]}' frameborder="0" allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture' allowfullscreen></iframe>${finishModal}`;
            }
        } else if (url.indexOf("vimeo") !== -1) {
            // console.log("is Vimeo")
            const vimeoURL = this.dataset.url;
            const regExp = /https:\/\/(www\.)?vimeo.com\/(\d+)($|\/)/;
            const match = vimeoURL.match(regExp);
            if (match) document.getElementById("lvideo-wrap").innerHTML = `${startModal}<iframe title="Vimeo" src="https://player.vimeo.com/video/${match[2]}?autoplay=1&loop=1" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>${finishModal}`;
            else alert("Not a Vimeo!  URL example:\n https://vimeo.com/120206922");
        } else if (url.indexOf("mp4") !== -1 || url.indexOf("m4v") !== -1) document.getElementById("lvideo-wrap").innerHTML = `${startModal}<video controls loop playsinline autoplay><source src='${this.dataset.url}' type="video/mp4"></video>${finishModal}`;
        else alert("No video link found.");
        document.querySelectorAll(".lvideo-overlay, .lvideo-close").forEach((e)=>e.addEventListener("click", lvideoClose));
    }
    function lvideoClose() {
        document.body.classList.remove("lvideo-active");
        const wrapper = document.getElementById("lvideo-wrap");
        wrapper.parentNode.removeChild(wrapper);
    }
    // LAUNCH
    function lvideo() {}
})(window.jQuery);


//# sourceMappingURL=main.js.map
